module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-02.1.12a748a9.jpg";